import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createParseResponseMiddleware } from './middleware/parse-response';
import { HttpError } from './errors';
var ClientMiddlewareRunStatus;

(function (ClientMiddlewareRunStatus) {
  ClientMiddlewareRunStatus["Running"] = "running";
  ClientMiddlewareRunStatus["Finished"] = "finished";
  ClientMiddlewareRunStatus["Repeating"] = "repeating";
  ClientMiddlewareRunStatus["Error"] = "error";
})(ClientMiddlewareRunStatus || (ClientMiddlewareRunStatus = {}));

export var requestWithMiddleware = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params, middleware) {
    var _middleware$response, _middleware$error;

    var responseMiddleware, errorMiddleware, info, init, deserializer, jwtProvider, fetch, userState, execMiddleware, _execMiddleware, execFetch;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _execMiddleware = function _execMiddleware3() {
              _execMiddleware = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(argument, middlewareChain) {
                var runState, end, repeat, _iterator, _step, _middleware;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        runState = {
                          status: ClientMiddlewareRunStatus.Running,
                          result: null
                        };

                        end = function end(result) {
                          if (result instanceof Error) {
                            runState.status = ClientMiddlewareRunStatus.Error;
                            runState.error = result;
                          } else {
                            runState.status = ClientMiddlewareRunStatus.Finished;
                            runState.result = result;
                          }
                        };

                        repeat = function repeat() {
                          runState.status = ClientMiddlewareRunStatus.Repeating;
                        };

                        _iterator = _createForOfIteratorHelperLoose(middlewareChain);

                      case 4:
                        if ((_step = _iterator()).done) {
                          _context3.next = 21;
                          break;
                        }

                        _middleware = _step.value;
                        _context3.prev = 6;
                        _context3.next = 9;
                        return _middleware(argument, {
                          fetch: fetch,
                          init: init,
                          info: info,
                          end: end,
                          repeat: repeat,
                          state: userState,
                          deserializer: deserializer,
                          jwtProvider: jwtProvider
                        });

                      case 9:
                        userState = _context3.sent;
                        _context3.next = 17;
                        break;

                      case 12:
                        _context3.prev = 12;
                        _context3.t0 = _context3["catch"](6);
                        runState.status = ClientMiddlewareRunStatus.Error;
                        runState.error = _context3.t0;
                        return _context3.abrupt("break", 21);

                      case 17:
                        if (!(runState.status !== ClientMiddlewareRunStatus.Running)) {
                          _context3.next = 19;
                          break;
                        }

                        return _context3.abrupt("break", 21);

                      case 19:
                        _context3.next = 4;
                        break;

                      case 21:
                        if (runState.status === ClientMiddlewareRunStatus.Running) {
                          runState.status = ClientMiddlewareRunStatus.Finished;
                          runState.result = argument;
                        }

                        return _context3.abrupt("return", runState);

                      case 23:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[6, 12]]);
              }));
              return _execMiddleware.apply(this, arguments);
            };

            execMiddleware = function _execMiddleware2(_x3, _x4) {
              return _execMiddleware.apply(this, arguments);
            };

            responseMiddleware = new Array().concat((_middleware$response = middleware == null ? void 0 : middleware.response) !== null && _middleware$response !== void 0 ? _middleware$response : []).concat(createParseResponseMiddleware());
            errorMiddleware = new Array().concat((_middleware$error = middleware == null ? void 0 : middleware.error) !== null && _middleware$error !== void 0 ? _middleware$error : []);
            info = params.info, init = params.init, deserializer = params.deserializer, jwtProvider = params.jwtProvider, fetch = params.fetch;
            userState = null;

            execFetch = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var processRun, headers, token, response, middlewareResponse, _response$headers$get;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        processRun = /*#__PURE__*/function () {
                          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(runState, execErrorMiddleware) {
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    _context.t0 = runState.status;
                                    _context.next = _context.t0 === ClientMiddlewareRunStatus.Finished ? 3 : _context.t0 === ClientMiddlewareRunStatus.Repeating ? 4 : _context.t0 === ClientMiddlewareRunStatus.Error ? 7 : _context.t0 === ClientMiddlewareRunStatus.Running ? 18 : 18;
                                    break;

                                  case 3:
                                    return _context.abrupt("return", runState.result);

                                  case 4:
                                    _context.next = 6;
                                    return execFetch();

                                  case 6:
                                    return _context.abrupt("return", _context.sent);

                                  case 7:
                                    if (!runState.error) {
                                      _context.next = 17;
                                      break;
                                    }

                                    if (!execErrorMiddleware) {
                                      _context.next = 16;
                                      break;
                                    }

                                    _context.t1 = processRun;
                                    _context.next = 12;
                                    return execMiddleware(runState.error, errorMiddleware);

                                  case 12:
                                    _context.t2 = _context.sent;
                                    _context.next = 15;
                                    return (0, _context.t1)(_context.t2, false);

                                  case 15:
                                    return _context.abrupt("return", _context.sent);

                                  case 16:
                                    throw runState.error;

                                  case 17:
                                    throw Error("Middleware run status is \"" + runState.status + ", but no error was set.");

                                  case 18:
                                    throw Error("Unpredictable middleware run status \"" + runState.status + "\". Check your middleware functions.");

                                  case 19:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }));

                          return function processRun(_x5, _x6) {
                            return _ref3.apply(this, arguments);
                          };
                        }();

                        headers = init.headers;
                        _context2.next = 4;
                        return jwtProvider == null ? void 0 : jwtProvider.get();

                      case 4:
                        token = _context2.sent;

                        if (token && (init == null ? void 0 : init.headers) != null) {
                          headers['Authorization'] = "Bearer " + token;
                        }

                        response = null;
                        _context2.prev = 7;
                        _context2.next = 10;
                        return fetch(info, init);

                      case 10:
                        response = _context2.sent;
                        _context2.next = 22;
                        break;

                      case 13:
                        _context2.prev = 13;
                        _context2.t0 = _context2["catch"](7);
                        _context2.t1 = processRun;
                        _context2.next = 18;
                        return execMiddleware(_context2.t0, errorMiddleware);

                      case 18:
                        _context2.t2 = _context2.sent;
                        _context2.next = 21;
                        return (0, _context2.t1)(_context2.t2, false);

                      case 21:
                        return _context2.abrupt("return", _context2.sent);

                      case 22:
                        if (response.ok) {
                          _context2.next = 38;
                          break;
                        }

                        _context2.t3 = processRun;
                        _context2.t4 = execMiddleware;
                        _context2.t5 = HttpError;
                        _context2.t6 = response.status;
                        _context2.next = 29;
                        return response.text();

                      case 29:
                        _context2.t7 = _context2.sent;
                        _context2.t8 = new _context2.t5(_context2.t6, _context2.t7);
                        _context2.t9 = errorMiddleware;
                        _context2.next = 34;
                        return (0, _context2.t4)(_context2.t8, _context2.t9);

                      case 34:
                        _context2.t10 = _context2.sent;
                        _context2.next = 37;
                        return (0, _context2.t3)(_context2.t10, false);

                      case 37:
                        return _context2.abrupt("return", _context2.sent);

                      case 38:
                        _context2.t11 = processRun;
                        _context2.next = 41;
                        return execMiddleware(response, responseMiddleware);

                      case 41:
                        _context2.t12 = _context2.sent;
                        _context2.next = 44;
                        return (0, _context2.t11)(_context2.t12, true);

                      case 44:
                        middlewareResponse = _context2.sent;

                        if (!(jwtProvider && middlewareResponse.headers)) {
                          _context2.next = 48;
                          break;
                        }

                        _context2.next = 48;
                        return jwtProvider.set((_response$headers$get = response.headers.get('x-jwt')) !== null && _response$headers$get !== void 0 ? _response$headers$get : '');

                      case 48:
                        return _context2.abrupt("return", middlewareResponse);

                      case 49:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[7, 13]]);
              }));

              return function execFetch() {
                return _ref2.apply(this, arguments);
              };
            }();

            _context4.next = 9;
            return execFetch();

          case 9:
            return _context4.abrupt("return", _context4.sent);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function requestWithMiddleware(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
//# sourceMappingURL=middleware.js.map